import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { UIRouterModule } from '@uirouter/angular';
import { TranslateModule } from '@ngx-translate/core';

import { CssRulesAngularModule } from 'rev-shared/ui/css/Css.AngularModule';
import { SecurityAngularModule } from 'rev-shared/security/SecurityAngular.Module';
import { VbBtnSecondaryDirective } from 'rev-shared/ui/buttons/VbBtnSecondary.Directive';
import { VbDropdownMenuModule } from 'rev-shared/ui/dropdown-menu/VbDropdownMenu.Module';

import { NotificationAngularModule } from '../../notifications/NotificationAngular.Module';
import { NotificationsMenuButtonComponent } from './NotificationsMenuButton.Component';
import { NotificationsMenuContentComponent } from './NotificationsMenuContent.Component';

const components = [
	NotificationsMenuButtonComponent,
	NotificationsMenuContentComponent
];

@NgModule({
	declarations: [
		components
	],
	imports: [
		CommonModule,
		TranslateModule,
		NotificationAngularModule,
		BsDropdownModule,
		UIRouterModule,
		CssRulesAngularModule,
		SecurityAngularModule,
		VbBtnSecondaryDirective,
		VbDropdownMenuModule
	],
	exports: [
		components
	]
})
export class NotificationsMenuModule { }
